/**
 * Allys Property Gallery Component
 * 
 * Allys-themed wrapper for PropertyGallery - clean styling
 */

'use client';

import { PropertyGallery, type PropertyGalleryProps } from '@/components/properties';

export function AllysPropertyGallery(props: PropertyGalleryProps) {
  return (
    <div 
      className="relative font-inter"
    >
      <PropertyGallery {...props} className="" />
    </div>
  );
}
